import { Course } from "./courses"


const a_level_maths = {
    "pure mathematics": {
        "algebra and functions": [
            "algebraic manipulation",
            "surds and rationalising",
            "indices and exponentials",
            "functions and mappings",
            "composite and inverse functions",
            "graph transformations",
            "polynomials and factor theorem",
            "remainder theorem",
            "solving equations"
        ],
        "coordinate geometry": [
            "straight lines and gradients",
            "midpoints and distance",
            "equations of lines",
            "circles and their equations",
            "tangents and normals",
            "geometric proofs"
        ],
        "calculus": [
            "differentiation from first principles",
            "rules of differentiation",
            "stationary points",
            "curve sketching with calculus",
            "integration as the reverse of differentiation",
            "definite integrals and area under curves",
            "integration by substitution",
            "integration by parts",
            "solving differential equations"
        ],
        "sequences and series": [
            "arithmetic sequences",
            "geometric sequences",
            "nth term formulas",
            "sum of series",
            "sigma notation",
            "binomial expansion",
            "convergence and divergence"
        ],
        "trigonometry": [
            "basic trigonometric ratios",
            "radians",
            "graphs of trig functions",
            "identities and equations",
            "double angle formulas",
            "addition formulas",
            "inverse trig functions",
            "solving trigonometric equations"
        ],
        "vectors": [
            "notation and representation",
            "magnitude and direction",
            "vector addition and subtraction",
            "scalar multiplication",
            "dot product",
            "vector equations of lines",
            "intersection and angle between lines"
        ],
        "proof": [
            "proof by deduction",
            "proof by exhaustion",
            "disproof by counterexample",
            "proof by contradiction",
            "mathematical induction (occasionally included)"
        ],
        "exponentials and logarithms": [
            "laws of logarithms",
            "natural logarithms and base e",
            "exponential growth and decay",
            "solving exponential and log equations",
            "logarithmic scales"
        ]
    },
    "statistics": {
        "data presentation and interpretation": [
            "measures of central tendency",
            "measures of spread (variance, SD)",
            "histograms",
            "box plots",
            "cumulative frequency graphs",
            "scatter diagrams and correlation",
            "outliers and skewness",
            "coding of data"
        ],
        "probability": [
            "basic probability rules",
            "Venn diagrams and set notation",
            "tree diagrams",
            "conditional probability",
            "independent and mutually exclusive events",
            "combinatorics (permutations and combinations)"
        ],
        "statistical distributions": [
            "discrete random variables",
            "binomial distribution",
            "normal distribution",
            "standard normal (Z) distribution",
            "approximations using normal/binomial",
            "inverse normal calculations"
        ],
        "statistical hypothesis testing": [
            "null and alternative hypotheses",
            "one-tailed and two-tailed tests",
            "critical regions",
            "significance levels",
            "binomial hypothesis tests",
            "normal distribution hypothesis tests"
        ]
    },
    "mechanics": {
        "kinematics": [
            "constant acceleration formulas (SUVAT)",
            "velocity-time and displacement-time graphs",
            "variable acceleration",
            "calculus in kinematics",
            "projectile motion"
        ],
        "forces and newton laws": [
            "types of forces (weight, tension, friction)",
            "resultant forces",
            "Newton's laws of motion",
            "equilibrium and resolving forces",
            "connected particles"
        ],
        "statics": [
            "equilibrium of particles",
            "resolving in two dimensions",
            "friction in equilibrium problems",
            "ladders and moments (in extended syllabi)"
        ],
        "momentum and impulse": [
            "linear momentum",
            "conservation of momentum",
            "collisions and explosions",
            "impulse and force-time graphs"
        ],
        "work energy and power": [
            "work done by a force",
            "kinetic and potential energy",
            "conservation of energy",
            "power and efficiency"
        ]
    },
    "discrete mathematics": {
        "graph theory": [
            "graph definitions and terminology",
            "Eulerian and Hamiltonian circuits",
            "adjacency and incidence matrices",
            "planar graphs and graph coloring",
            "shortest path algorithms (Dijkstra, Floyd-Warshall)"
        ],
        "combinatorics": [
            "fundamental counting principle",
            "permutations and combinations",
            "pigeonhole principle",
            "binomial coefficients and Pascal's triangle",
            "inclusion-exclusion principle"
        ],
        "set theory and logic": [
            "sets, subsets, and Venn diagrams",
            "operations on sets (union, intersection, complement)",
            "propositional logic and truth tables",
            "predicate logic and quantifiers",
            "logical equivalences and De Morgan's laws"
        ],
        "recurrence relations": [
            "definition and examples",
            "solving linear recurrence relations",
            "Fibonacci sequence",
            "applications in counting problems",
            "tower of Hanoi problem"
        ],
        "algorithms and complexity": [
            "basic algorithm design",
            "sorting algorithms (bubble, insertion, quicksort)",
            "searching algorithms (linear, binary)",
            "Big O notation and time complexity",
            "greedy algorithms and dynamic programming"
        ]
    }
}
const a_level_biology = {
    "Biological Molecules": {
        "Molecules and Biochemistry": [
            "Carbohydrates",
            "Lipids",
            "Proteins",
            "Enzymes",
            "Water",
            "Inorganic Ions",
            "Nucleic Acids (DNA and RNA)",
            "ATP",
            "DNA Replication"
        ]
    },
    "Cells": {
        "Cell Structure and Function": [
            "Prokaryotic and Eukaryotic Cells",
            "Microscopy and Magnification",
            "Cell Organelles",
            "Cell Specialisation",
            "Cell Fractionation",
            "Viruses and Cell Theory",
            "The Cell Cycle",
            "Mitosis and Meiosis"
        ],
        "Transport Across Membranes": [
            "Diffusion and Osmosis",
            "Active Transport",
            "Facilitated Diffusion",
            "Co-transport",
            "Endocytosis and Exocytosis",
            "Water Potential"
        ],
        "Immune System": [
            "Phagocytosis",
            "Lymphocytes",
            "Antibodies",
            "Vaccination",
            "Monoclonal Antibodies",
            "HIV and AIDS",
            "Immune Response"
        ]
    },
    "Exchange and Transport": {
        "Exchange Surfaces": [
            "Surface Area to Volume Ratio",
            "Gas Exchange in Humans",
            "Gas Exchange in Insects and Fish",
            "Adaptations of Exchange Surfaces",
            "Diffusion and Ventilation"
        ],
        "Transport in Animals": [
            "Circulatory Systems",
            "Heart Structure and Function",
            "Cardiac Cycle",
            "Blood Vessels",
            "Blood Components",
            "Tissue Fluid",
            "Haemoglobin and Oxygen Transport"
        ],
        "Transport in Plants": [
            "Xylem and Phloem",
            "Transpiration",
            "Translocation",
            "Cohesion-Tension Theory",
            "Root Pressure",
            "Factors Affecting Transport"
        ]
    },
    "Genetics and Evolution": {
        "Genetic Information": [
            "Structure of DNA and RNA",
            "Genes and Polypeptides",
            "Mutations",
            "Gene Expression",
            "Genome and Proteome",
            "Regulation of Transcription and Translation"
        ],
        "Genetic Diversity": [
            "Sources of Variation",
            "Natural Selection",
            "Speciation",
            "Adaptations and Selection Types",
            "Evolutionary Relationships",
            "Classification and Taxonomy"
        ],
        "Inheritance": [
            "Monohybrid and Dihybrid Crosses",
            "Codominance",
            "Multiple Alleles",
            "Sex Linkage",
            "Pedigree Analysis",
            "Chi-Squared Test"
        ]
    },
    "Organisms and Their Environment": {
        "Energy Transfers in Ecosystems": [
            "Photosynthesis",
            "Respiration",
            "Energy Flow",
            "Food Chains and Webs",
            "Efficiency of Energy Transfer",
            "Pyramids of Biomass"
        ],
        "Nutrient Cycles": [
            "Carbon Cycle",
            "Nitrogen Cycle",
            "Phosphorus Cycle",
            "Decomposers and Detritivores",
            "Fertilisers and Eutrophication"
        ],
        "Population and Ecosystems": [
            "Abiotic and Biotic Factors",
            "Ecological Succession",
            "Population Growth",
            "Mark-Release-Recapture",
            "Conservation and Sustainability"
        ]
    },
    "Control Systems": {
        "Homeostasis": [
            "Negative Feedback",
            "Control of Blood Glucose",
            "Insulin and Glucagon",
            "Diabetes",
            "Temperature Regulation",
            "Osmoregulation"
        ],
        "Nervous Coordination": [
            "Neurones and Synapses",
            "Resting and Action Potentials",
            "Synaptic Transmission",
            "Reflex Arcs",
            "Nervous vs Hormonal Control"
        ],
        "Muscles and Movement": [
            "Sliding Filament Theory",
            "Structure of Muscle",
            "Neuromuscular Junction",
            "ATP and Muscle Contraction"
        ]
    },
    "Gene Technologies": {
        "Recombinant DNA Technology": [
            "Restriction Enzymes",
            "PCR and Gel Electrophoresis",
            "Gene Probes",
            "DNA Fingerprinting",
            "Genetically Modified Organisms",
            "Gene Therapy",
            "Ethical Considerations"
        ]
    }
}
const a_level_economics = {
    "Microeconomics": {
        "Introduction to Markets and Market Failure": [
            "Economic Problem and Resource Allocation",
            "Production Possibility Frontiers",
            "Types of Economies",
            "Demand and Supply",
            "Elasticities (PED, PES, YED, XED)",
            "Consumer and Producer Surplus",
            "Price Mechanism",
            "Indirect Taxes and Subsidies",
            "Price Controls",
            "Market Failure and Externalities"
        ],
        "Market Structures": [
            "Perfect Competition",
            "Monopolistic Competition",
            "Oligopoly",
            "Monopoly",
            "Contestable Markets",
            "Price and Non-price Competition",
            "Barriers to Entry and Exit"
        ],
        "Labour Market": [
            "Demand and Supply of Labour",
            "Wage Determination",
            "Labour Market Failure",
            "Minimum and Maximum Wages",
            "Trade Unions",
            "Discrimination in Labour Markets",
            "Income and Wealth Inequality"
        ],
        "Government Intervention": [
            "Reasons for Government Intervention",
            "Regulation and Deregulation",
            "Taxation and Subsidies",
            "State Provision of Public Goods",
            "Tradable Pollution Permits",
            "Cost-Benefit Analysis",
            "Government Failure"
        ]
    },
    "Macroeconomics": {
        "Economic Performance": [
            "Economic Growth",
            "Inflation",
            "Unemployment",
            "Balance of Payments",
            "Measuring Economic Performance",
            "Short-run and Long-run Growth"
        ],
        "Aggregate Demand and Aggregate Supply": [
            "Components of Aggregate Demand",
            "Shifts in AD and AS",
            "Keynesian vs Classical AS",
            "Macroeconomic Equilibrium",
            "Multiplier Effect"
        ],
        "Government Economic Policy": [
            "Fiscal Policy",
            "Monetary Policy",
            "Supply-side Policies",
            "Policy Conflicts and Trade-offs",
            "Evaluation of Policy Effectiveness"
        ],
        "Financial Markets and Monetary Policy": [
            "Role of Central Banks",
            "Money Supply",
            "Interest Rates",
            "Quantitative Easing",
            "Regulation of Financial Markets",
            "Functions of Financial Institutions"
        ],
        "International Economics": [
            "Globalisation",
            "Free Trade and Protectionism",
            "Exchange Rates",
            "Balance of Payments",
            "Trade Blocs and WTO",
            "Absolute and Comparative Advantage",
            "International Competitiveness"
        ],
        "Development and Growth": [
            "Measures of Development (HDI, GDP per capita)",
            "Barriers to Development",
            "Aid and Debt Relief",
            "Role of Institutions",
            "Policies to Promote Growth",
            "Inequality Between Countries"
        ]
    }
}
const a_level_physics = {
    "Measurements and Their Errors": {
        "Physical Quantities and Units": [
            "SI Units and Prefixes",
            "Base and Derived Units",
            "Unit Conversions",
            "Dimensional Analysis"
        ],
        "Uncertainty and Accuracy": [
            "Systematic and Random Errors",
            "Precision and Accuracy",
            "Uncertainty Calculations",
            "Significant Figures",
            "Graphical Analysis and Best Fit Lines"
        ]
    },
    "Particles and Radiation": {
        "Atomic Structure": [
            "Subatomic Particles",
            "Isotopes",
            "Nuclear Notation",
            "Fundamental Forces"
        ],
        "Particles and Antiparticles": [
            "Matter and Antimatter",
            "Photons and Energy of a Photon",
            "Annihilation and Pair Production",
            "Conservation Laws"
        ],
        "Quarks and Leptons": [
            "Quark Structure of Hadrons",
            "Leptons and Muons",
            "Beta Decay",
            "Quark Confinement",
            "Strangeness"
        ],
        "Photon and Wave Properties": [
            "The Photoelectric Effect",
            "Einstein’s Photoelectric Equation",
            "Electron Volts",
            "Wave-Particle Duality"
        ]
    },
    "Mechanics and Materials": {
        "Forces and Motion": [
            "Displacement, Velocity, and Acceleration",
            "Equations of Motion",
            "Free Fall and Terminal Velocity",
            "Projectile Motion",
            "Newton’s Laws"
        ],
        "Forces in Action": [
            "Free Body Diagrams",
            "Resultant Forces",
            "Moments and Couples",
            "Centre of Mass",
            "Conditions for Equilibrium"
        ],
        "Materials": [
            "Stress, Strain, and Young Modulus",
            "Hooke’s Law",
            "Elastic and Plastic Deformation",
            "Stress-Strain Graphs",
            "Work Done in Stretching"
        ],
        "Energy and Power": [
            "Work Done",
            "Kinetic and Potential Energy",
            "Conservation of Energy",
            "Efficiency",
            "Power and Force-Displacement Graphs"
        ]
    },
    "Electricity": {
        "Current Electricity": [
            "Charge and Current",
            "Potential Difference and EMF",
            "Resistance and Ohm’s Law",
            "IV Characteristics",
            "Resistors and Diodes"
        ],
        "DC Circuits": [
            "Series and Parallel Circuits",
            "Internal Resistance",
            "Kirchhoff’s Laws",
            "Potential Dividers",
            "Electromotive Force and Terminal p.d."
        ]
    },
    "Waves": {
        "Wave Properties": [
            "Transverse and Longitudinal Waves",
            "Wave Speed, Frequency, and Wavelength",
            "Phase and Phase Difference",
            "Superposition and Interference",
            "Diffraction"
        ],
        "Refraction and Diffraction": [
            "Snell’s Law",
            "Critical Angle and TIR",
            "Optical Fibres",
            "Single and Double Slit Diffraction"
        ],
        "Stationary Waves": [
            "Formation and Conditions",
            "Harmonics and Nodes",
            "Comparison with Progressive Waves"
        ]
    },
    "Further Mechanics and Thermal Physics": {
        "Circular Motion": [
            "Angular Velocity",
            "Centripetal Force and Acceleration",
            "Applications of Circular Motion"
        ],
        "Simple Harmonic Motion": [
            "Conditions and Definitions",
            "SHM Equations",
            "Graphs and Energy in SHM",
            "Damping and Resonance"
        ],
        "Thermal Physics": [
            "Internal Energy and Specific Heat Capacity",
            "Specific Latent Heat",
            "The Kinetic Model",
            "Ideal Gas Equation",
            "Brownian Motion"
        ]
    },
    "Fields and Their Consequences": {
        "Gravitational Fields": [
            "Newton’s Law of Gravitation",
            "Gravitational Potential",
            "Orbital Motion",
            "Kepler’s Laws"
        ],
        "Electric Fields": [
            "Coulomb’s Law",
            "Electric Field Strength",
            "Potential and Potential Difference",
            "Capacitance and Energy Stored",
            "Charging and Discharging Capacitors"
        ],
        "Magnetic Fields": [
            "Magnetic Flux Density",
            "Force on a Current-Carrying Wire",
            "Motion of Charged Particles",
            "Electromagnetic Induction",
            "Transformers and Generators"
        ]
    },
    "Nuclear Physics": {
        "Radioactivity": [
            "Types of Radiation",
            "Decay Equations",
            "Activity and Half-life",
            "Exponential Decay",
            "Uses of Radioactivity"
        ],
        "Nuclear Energy": [
            "Mass-Energy Equivalence",
            "Binding Energy and Nuclear Stability",
            "Fission and Fusion",
            "Nuclear Power and Safety",
            "Control of Nuclear Reactions"
        ]
    },
    "Optional Topics (varies by board)": {
        "Examples": [
            "Astrophysics",
            "Medical Physics",
            "Engineering Physics",
            "Turning Points in Physics",
            "Electronics",
            "Applied Physics"
        ]
    }
}
const a_level_chemistry = {
    "Physical Chemistry": {
        "Atomic Structure": [
            "Fundamental Particles",
            "Isotopes and Relative Mass",
            "Mass Spectrometry",
            "Electron Configuration",
            "Ionisation Energies"
        ],
        "Amount of Substance": [
            "The Mole and Avogadro’s Constant",
            "Empirical and Molecular Formulae",
            "Reacting Masses and Volumes",
            "Ideal Gas Equation",
            "Percentage Yield and Atom Economy"
        ],
        "Bonding and Structure": [
            "Ionic, Covalent and Metallic Bonding",
            "Intermolecular Forces",
            "Shapes of Molecules",
            "Polarity",
            "Macromolecules and Physical Properties"
        ],
        "Energetics": [
            "Exothermic and Endothermic Reactions",
            "Enthalpy Change Definitions",
            "Calorimetry",
            "Hess's Law",
            "Bond Enthalpies"
        ],
        "Kinetics": [
            "Collision Theory",
            "Factors Affecting Rate",
            "Catalysis",
            "Rate Equations and Orders",
            "Rate Constant and Half-life"
        ],
        "Chemical Equilibria and Le Chatelier’s Principle": [
            "Dynamic Equilibrium",
            "Equilibrium Constant (Kc)",
            "Effect of Conditions on Equilibrium",
            "Industrial Applications (e.g. Haber Process)"
        ],
        "Acids, Bases and pH": [
            "Brønsted–Lowry Theory",
            "pH Calculations",
            "Strong vs Weak Acids and Bases",
            "Buffers",
            "Titration Curves and Indicators"
        ],
        "Thermodynamics (advanced)": [
            "Lattice Enthalpy",
            "Born–Haber Cycles",
            "Entropy and Spontaneity",
            "Gibbs Free Energy"
        ],
        "Electrochemistry": [
            "Redox and Electrode Potentials",
            "Electrochemical Cells",
            "Feasibility of Reactions",
            "Fuel Cells"
        ]
    },
    "Inorganic Chemistry": {
        "Periodic Table and Trends": [
            "Group 2 Reactions and Trends",
            "Group 7 (Halogens)",
            "Displacement and Disproportionation",
            "Reactions of Period 3 Oxides",
            "Trends in Atomic Properties"
        ],
        "Redox Reactions": [
            "Oxidation Numbers",
            "Balancing Redox Equations",
            "Redox Titrations",
            "Disproportionation Reactions"
        ],
        "Transition Metals": [
            "Electron Configurations",
            "Ligand Substitution",
            "Complex Ions",
            "Color and Spectra",
            "Catalysis and Redox Chemistry"
        ],
        "Qualitative Analysis": [
            "Tests for Ions (Flame Tests, Precipitation)",
            "Gas Tests",
            "Testing for Anions and Cations",
            "Analysis of Unknown Substances"
        ]
    },
    "Organic Chemistry": {
        "Introduction to Organic Chemistry": [
            "Nomenclature and Formulae",
            "Isomerism (Structural and Stereoisomerism)",
            "Functional Groups",
            "Reaction Mechanisms Overview"
        ],
        "Alkanes and Alkenes": [
            "Combustion and Free Radical Substitution",
            "Electrophilic Addition",
            "Industrial Cracking",
            "Polymers from Alkenes"
        ],
        "Haloalkanes": [
            "Nucleophilic Substitution",
            "Hydrolysis and Halogen Test",
            "Ozone Depletion Chemistry"
        ],
        "Alcohols and Oxidation": [
            "Oxidation Reactions",
            "Dehydration of Alcohols",
            "Esterification",
            "Uses of Alcohols"
        ],
        "Aromatic Chemistry": [
            "Structure of Benzene",
            "Electrophilic Substitution Reactions",
            "Nitration and Friedel-Crafts Acylation"
        ],
        "Carbonyl Compounds": [
            "Aldehydes and Ketones",
            "Nucleophilic Addition",
            "Tollens' and Fehling's Tests"
        ],
        "Carboxylic Acids and Derivatives": [
            "Acid Reactions",
            "Esterification and Hydrolysis",
            "Acyl Chlorides and Acid Anhydrides",
            "Mechanisms of Nucleophilic Addition-Elimination"
        ],
        "Amines, Amino Acids and Polymers": [
            "Basicity of Amines",
            "Synthesis of Amines",
            "Zwitterions",
            "Peptide Linkages",
            "Addition and Condensation Polymers"
        ],
        "Organic Synthesis and Analysis": [
            "Synthetic Routes and Reagents",
            "Functional Group Interconversions",
            "Test Tube Reactions",
            "Spectroscopy (IR and NMR)",
            "Mass Spectrometry"
        ]
    }
}
const a_level_english_literature = {
    "Genres and Literary Forms": {
        "Drama": [
            "Shakespearean Tragedy",
            "Modern Tragedy",
            "Comedy (Classical and Modern)",
            "Problem Plays",
            "Political Drama",
            "Dramatic Structure and Form",
            "Dialogue and Stage Directions",
            "Characterisation in Drama"
        ],
        "Prose": [
            "The Novel (18th to 21st Century)",
            "Narrative Structure",
            "First-person and Omniscient Narration",
            "Character and Setting",
            "Themes in Prose (e.g., Love, Power, Gender)",
            "Gothic Literature",
            "Science Fiction and Dystopia",
            "Bildungsroman"
        ],
        "Poetry": [
            "Metaphysical Poetry",
            "Romantic Poetry",
            "Victorian Poetry",
            "Modern and Contemporary Poetry",
            "Poetic Form and Structure",
            "Sound and Rhythm",
            "Imagery and Figurative Language",
            "Thematic Analysis"
        ]
    },
    "Historical and Social Contexts": {
        "Pre-1900 Literature": [
            "Shakespearean Contexts",
            "Renaissance and Restoration",
            "Romanticism",
            "Victorian Society and Morality",
            "19th Century Gender Roles",
            "Industrialisation and Class"
        ],
        "20th and 21st Century Literature": [
            "Modernism and Postmodernism",
            "War and Literature (WWI, WWII)",
            "Postcolonialism",
            "Feminist Literary Perspectives",
            "Race and Identity",
            "Contemporary Social Issues"
        ]
    },
    "Themes and Comparative Analysis": {
        "Love Through the Ages": [
            "Unrequited Love",
            "Courtly Love",
            "Marriage and Duty",
            "Sexuality and Desire",
            "Love and Death",
            "Idealised vs Realistic Love",
            "Power Dynamics in Love"
        ],
        "Tragedy": [
            "Tragic Hero and Hamartia",
            "Catharsis and Audience Response",
            "Fate vs Free Will",
            "Violence and Suffering",
            "Order and Disorder",
            "Hubris and Nemesis"
        ],
        "Crime and Detection": [
            "The Criminal and the Victim",
            "Justice and Injustice",
            "Moral Ambiguity",
            "The Role of the Detective",
            "Corruption and Power",
            "Truth and Lies"
        ],
        "Political and Social Protest Writing": [
            "Oppression and Rebellion",
            "Voice of the Marginalised",
            "Power and Corruption",
            "Freedom and Constraint",
            "The Role of the Individual vs Society"
        ]
    },
    "Critical Theory and Literary Analysis": {
        "Literary Criticism Approaches": [
            "Feminist Criticism",
            "Marxist Criticism",
            "Psychoanalytic Criticism",
            "Postcolonial Criticism",
            "Narratology",
            "Reader-Response Theory",
            "Structuralism and Deconstruction"
        ],
        "Analytical Skills": [
            "Close Reading",
            "Interpreting Language and Imagery",
            "Comparative Analysis",
            "Form, Structure and Language",
            "Writer’s Intent and Audience Response",
            "Evaluating Critical Interpretations"
        ]
    }
}
const a_level_english_language = {
    "Language Levels and Frameworks": {
        "Lexis and Semantics": [
            "Word Classes",
            "Denotation and Connotation",
            "Field-Specific Lexis",
            "Semantic Fields",
            "Collocations and Idioms",
            "Figurative Language"
        ],
        "Grammar and Syntax": [
            "Sentence Types and Functions",
            "Clause Structures",
            "Word Order and Syntactic Variation",
            "Tense and Aspect",
            "Voice (Active/Passive)",
            "Standard and Non-Standard Grammar"
        ],
        "Phonetics, Phonology and Prosodics": [
            "IPA and Pronunciation",
            "Accent and Dialect Features",
            "Stress and Intonation",
            "Sound Symbolism",
            "Alliteration and Rhyme",
            "Paralinguistic Features"
        ],
        "Discourse": [
            "Discourse Structure and Markers",
            "Modes of Communication",
            "Genre and Register",
            "Narrative Structure",
            "Coherence and Cohesion"
        ],
        "Graphology": [
            "Typography and Layout",
            "Visual Signifiers",
            "Font and Colour Use",
            "Multimodal Texts",
            "Images and Graphical Elements"
        ],
        "Pragmatics": [
            "Implied Meaning",
            "Politeness Theories",
            "Grice’s Maxims",
            "Speech Acts",
            "Contextual Influences"
        ]
    },
    "Language Diversity and Change": {
        "Regional and Social Variation": [
            "Accents and Dialects in the UK",
            "Social Class and Language",
            "Ethnicity and Language",
            "Gender and Language",
            "Occupation and Jargon",
            "Code-Switching"
        ],
        "Language and Gender": [
            "Deficit and Dominance Models",
            "Difference and Diversity Approaches",
            "Tag Questions and Hedges",
            "Gendered Lexis and Discourse",
            "Representation of Gender in Media"
        ],
        "Language and Ethnicity": [
            "Ethnolects and Multicultural English",
            "Creoles and Pidgins",
            "Language and Identity",
            "Cultural Code-Switching"
        ],
        "Language Change": [
            "Historical Development of English",
            "Borrowing and Neologisms",
            "Semantic Shift",
            "Prescriptivism vs Descriptivism",
            "Technology and Change",
            "Global English"
        ]
    },
    "Child Language Development": {
        "Spoken Language Acquisition": [
            "Pre-linguistic and Holophrastic Stages",
            "Two-Word and Telegraphic Stages",
            "Phonological Development",
            "Theories of Language Acquisition",
            "Caregiver Language"
        ],
        "Written Language Development": [
            "Emergent Literacy",
            "Spelling Development",
            "Handwriting and Orthography",
            "Genres in Children’s Writing",
            "Influences of Reading on Writing"
        ],
        "Theories of Language Development": [
            "Skinner (Behaviourism)",
            "Chomsky (Nativism)",
            "Piaget (Cognitivism)",
            "Bruner (Interactionism)",
            "Vygotsky (Sociocultural Theory)"
        ]
    },
    "Language in Action (NEA / Coursework Focus)": {
        "Original Writing": [
            "Audience and Purpose",
            "Register and Mode",
            "Voice and Style",
            "Genre Conventions",
            "Creative and Persuasive Writing"
        ],
        "Language Investigation": [
            "Choosing a Hypothesis",
            "Data Collection and Transcription",
            "Analytical Frameworks",
            "Contextual Factors",
            "Drawing Conclusions and Evaluation"
        ]
    }
}
const a_level_geography = {
    "Physical Geography": {
        "Water and Carbon Cycles": [
            "Systems in Physical Geography",
            "The Water Cycle (Stores, Flows, Processes)",
            "Drainage Basin Hydrology",
            "River Regimes and Hydrographs",
            "The Carbon Cycle (Fast and Slow Cycles)",
            "Carbon Sequestration",
            "Water and Carbon Feedback Loops",
            "Human Impact on Cycles",
            "Mitigation and Adaptation Strategies"
        ],
        "Coastal Systems and Landscapes": [
            "Coastal Zones and Processes",
            "Marine and Subaerial Processes",
            "Coastal Landforms (Erosional and Depositional)",
            "Sediment Cells",
            "Sea Level Change",
            "Coastal Management",
            "Case Studies of Coastal Environments"
        ],
        "Glacial Systems and Landscapes": [
            "Glacial Processes and Landforms",
            "Glacial Mass Balance",
            "Erosional and Depositional Features",
            "Periglacial Processes",
            "Glaciated Landscapes Case Studies",
            "Human Impacts in Glacial Environments"
        ],
        "Hazards": [
            "Tectonic Hazards (Earthquakes and Volcanoes)",
            "Tsunamis",
            "Tropical Storms",
            "Wildfires",
            "Hazard Risk and Perception",
            "Responses and Management",
            "Case Studies of Hazards"
        ],
        "Ecosystems and Biodiversity": [
            "Tropical Rainforests",
            "Hot Desert Systems",
            "Nutrient Cycling",
            "Succession and Climax Communities",
            "Deforestation and Desertification",
            "Conservation Strategies",
            "Human and Physical Interactions"
        ]
    },
    "Human Geography": {
        "Global Systems and Global Governance": [
            "Globalisation Processes and Flows",
            "International Trade and TNCs",
            "Global Governance Institutions (e.g. UN, WTO)",
            "Global Commons (e.g. Antarctica)",
            "Environmental Governance",
            "Case Studies: Globalisation Impacts"
        ],
        "Changing Places": [
            "Place and Space Concepts",
            "Perceptions of Place",
            "Endogenous and Exogenous Factors",
            "Place Representation and Media",
            "Case Studies: Local and Distant Places",
            "Regeneration and Rebranding"
        ],
        "Population and the Environment": [
            "Population Growth and Resources",
            "Carrying Capacity and Food Security",
            "Health, Disease, and Malnutrition",
            "Environmental Degradation",
            "Population Policies",
            "Sustainable Development"
        ],
        "Urban Environments": [
            "Urbanisation and Suburbanisation",
            "Urban Change and Regeneration",
            "Urban Climate and Air Quality",
            "Waste Management and Sustainability",
            "Social and Economic Inequality",
            "Case Studies: Urban Challenges"
        ],
        "Resource Security": [
            "Energy, Water, and Food Resources",
            "Patterns of Supply and Demand",
            "Resource Management Strategies",
            "Conflict Over Resources",
            "Technological Solutions"
        ]
    },
    "Geographical Skills and Fieldwork": {
        "Data Collection and Investigation": [
            "Sampling Methods",
            "Primary and Secondary Data",
            "Data Presentation Techniques",
            "GIS and Digital Mapping",
            "Field Sketching and Photography"
        ],
        "Statistical and Analytical Skills": [
            "Mean, Median, Mode",
            "Standard Deviation",
            "Spearman's Rank and Chi-Square",
            "Regression and Correlation",
            "Hypothesis Testing"
        ],
        "Fieldwork Investigation (NEA)": [
            "Choosing a Research Question",
            "Fieldwork Methodologies",
            "Risk Assessment and Ethics",
            "Data Analysis and Interpretation",
            "Evaluation and Conclusions"
        ]
    }
}
const a_level_computer_science = {
    "Fundamentals of Programming": {
        "Programming Concepts": [
            "Variables and Data Types",
            "Control Structures (IF, LOOP)",
            "Subroutines (Functions and Procedures)",
            "Scope and Recursion",
            "Error Handling and Debugging",
            "Data Validation and Verification"
        ],
        "Programming Paradigms": [
            "Procedural Programming",
            "Object-Oriented Programming (OOP)",
            "Functional Programming",
            "Event-Driven Programming"
        ],
        "Data Structures": [
            "Arrays and Lists",
            "Stacks and Queues",
            "Linked Lists",
            "Trees and Graphs",
            "Hash Tables"
        ],
        "Algorithms": [
            "Searching (Linear, Binary)",
            "Sorting (Bubble, Merge, Insertion, Quick)",
            "Pathfinding Algorithms",
            "Recursion",
            "Complexity and Efficiency (Big-O Notation)"
        ]
    },
    "Theory of Computation": {
        "Fundamentals of Algorithms": [
            "Algorithm Design and Analysis",
            "Pseudocode and Flowcharts",
            "Divide and Conquer Algorithms",
            "Greedy Algorithms",
            "Backtracking and Heuristics"
        ],
        "Formal Languages and Automata": [
            "Finite State Machines (FSM)",
            "Regular and Context-Free Languages",
            "Backus-Naur Form (BNF)",
            "Syntax Diagrams",
            "Turing Machines"
        ],
        "Computability and Complexity": [
            "Decidability",
            "Halting Problem",
            "NP-Completeness (basic overview)",
            "Tractable vs Intractable Problems"
        ]
    },
    "Computer Systems": {
        "Hardware and Software": [
            "CPU Architecture",
            "Fetch-Decode-Execute Cycle",
            "Registers and Buses",
            "Memory and Storage (RAM, ROM, SSD, HDD)",
            "Input and Output Devices",
            "System and Utility Software"
        ],
        "Boolean Logic": [
            "Logic Gates (AND, OR, NOT, XOR)",
            "Truth Tables",
            "Boolean Algebra Simplification",
            "Karnaugh Maps"
        ],
        "Assembly Language and Machine Code": [
            "Low-Level Languages",
            "Instruction Sets",
            "Assembly Language Syntax",
            "Little Man Computer (LMC) or similar"
        ]
    },
    "Data Representation and Databases": {
        "Data Representation": [
            "Binary, Denary, Hexadecimal",
            "Binary Arithmetic",
            "Character Encoding (ASCII, Unicode)",
            "Images and Sound Representation",
            "Floating Point Numbers"
        ],
        "Relational Databases": [
            "Database Design and Normalisation",
            "Entity-Relationship Diagrams",
            "SQL Queries",
            "Transactions and ACID",
            "Data Integrity and Redundancy"
        ]
    },
    "Computer Networks and Cyber Security": {
        "Networks and Communication": [
            "Network Topologies",
            "LAN, WAN and Internet",
            "Protocols (TCP/IP, HTTP, FTP, etc.)",
            "Packet Switching",
            "Client-Server vs Peer-to-Peer"
        ],
        "Network Security": [
            "Threats (Malware, Phishing, etc.)",
            "Encryption (Symmetric, Asymmetric)",
            "Firewalls and Access Control",
            "Penetration Testing",
            "Authentication Techniques"
        ],
        "Web Technologies": [
            "HTML and CSS Basics",
            "JavaScript Fundamentals",
            "Server vs Client-Side Processing",
            "Web Forms and Validation",
            "Cookies and Sessions"
        ]
    },
    "Software Development and Project Management": {
        "Software Development Life Cycle": [
            "Waterfall Model",
            "Agile Methodology",
            "Rapid Application Development (RAD)",
            "Spiral Model",
            "Prototyping"
        ],
        "Testing and Maintenance": [
            "Types of Testing (Unit, Integration, System)",
            "Black Box and White Box Testing",
            "Version Control Systems",
            "Debugging Tools"
        ],
        "Project Management": [
            "Project Planning and Gantt Charts",
            "Feasibility Study",
            "Documentation and Evaluation",
            "User Requirements and Feedback"
        ]
    },
    "Legal, Ethical and Environmental Issues": {
        "Ethical and Social Issues": [
            "Artificial Intelligence and Automation",
            "Privacy and Surveillance",
            "Digital Divide",
            "Ethical Hacking",
            "Bias in Algorithms"
        ],
        "Legal Issues": [
            "Data Protection Act (DPA)",
            "Computer Misuse Act",
            "Copyright and Licensing",
            "Freedom of Information Act",
            "Regulation of Investigatory Powers Act"
        ],
        "Environmental Impacts": [
            "E-Waste and Recycling",
            "Energy Consumption of Computing",
            "Sustainable Technology",
            "Green Computing Practices"
        ]
    }
}
const a_level_psychology = {
    "Introductory Topics in Psychology": {
        "Social Influence": [
            "Conformity (Asch, Types, Explanations)",
            "Obedience (Milgram)",
            "Explanations for Obedience (Agentic State, Legitimacy)",
            "Resistance to Social Influence",
            "Minority Influence",
            "Social Change"
        ],
        "Memory": [
            "Multi-Store Model of Memory",
            "Types of Long-Term Memory",
            "Working Memory Model",
            "Explanations for Forgetting",
            "Eyewitness Testimony (Misleading Info, Anxiety)",
            "Cognitive Interview"
        ],
        "Attachment": [
            "Caregiver-Infant Interactions",
            "Stages of Attachment",
            "Animal Studies (Lorenz, Harlow)",
            "Explanations (Learning Theory, Bowlby)",
            "Ainsworth’s Strange Situation",
            "Cultural Variations",
            "Maternal Deprivation",
            "Romanian Orphan Studies",
            "Influence on Later Relationships"
        ],
        "Psychopathology": [
            "Definitions of Abnormality",
            "Phobias, Depression, OCD – Characteristics",
            "Behavioural Approach to Phobias",
            "Cognitive Approach to Depression",
            "Biological Approach to OCD",
            "Treatments (CBT, Drug Therapy)"
        ]
    },
    "Approaches in Psychology": {
        "Psychological Approaches": [
            "Origins of Psychology",
            "Behaviourist Approach",
            "Social Learning Theory",
            "Cognitive Approach",
            "Biological Approach",
            "Psychodynamic Approach",
            "Humanistic Approach",
            "Comparison of Approaches"
        ]
    },
    "Biopsychology": {
        "Biological Basis of Behaviour": [
            "Nervous System Structure and Function",
            "Neurons and Synaptic Transmission",
            "Endocrine System and Fight-or-Flight",
            "Localisation of Brain Function",
            "Brain Plasticity and Functional Recovery",
            "Ways of Studying the Brain (fMRI, EEG, etc.)",
            "Biological Rhythms (Circadian, Infradian, Ultradian)",
            "Sleep-Wake Cycle"
        ]
    },
    "Research Methods": {
        "Experimental Design and Techniques": [
            "Types of Experiments",
            "Observational Techniques",
            "Self-Report Methods",
            "Correlations and Case Studies",
            "Sampling Methods",
            "Variables and Hypotheses"
        ],
        "Data Handling and Analysis": [
            "Descriptive Statistics (Mean, Median, Mode)",
            "Measures of Dispersion",
            "Graphs and Tables",
            "Statistical Testing",
            "Probability and Significance",
            "Choosing a Statistical Test"
        ],
        "Scientific Processes": [
            "Peer Review and Psychology as a Science",
            "Ethical Issues and Guidelines",
            "Validity and Reliability",
            "Control and Standardisation",
            "Pilot Studies and Hypothesis Formation"
        ]
    },
    "Issues and Options in Psychology": {
        "Issues and Debates": [
            "Gender and Culture in Psychology",
            "Free Will vs Determinism",
            "Nature vs Nurture",
            "Holism vs Reductionism",
            "Idiographic vs Nomothetic",
            "Ethical Implications of Research"
        ],
        "Relationships": [
            "Evolutionary Explanations",
            "Self-Disclosure",
            "Theories of Attraction",
            "Virtual Relationships",
            "Parasocial Relationships"
        ],
        "Schizophrenia": [
            "Classification and Diagnosis",
            "Biological Explanations (Genetics, Dopamine)",
            "Psychological Explanations (Family, Cognitive)",
            "Biological and Psychological Treatments",
            "Interactionist Approach (Diathesis-Stress Model)"
        ],
        "Aggression": [
            "Neural and Hormonal Mechanisms",
            "Genetic Factors",
            "Ethological Explanation",
            "Social Learning Theory",
            "Frustration-Aggression Hypothesis",
            "Deindividuation",
            "Institutional Aggression"
        ]
    }
}
const a_level_history = {
    "British History": {
        "Tudor England (1485–1603)": [
            "Henry VII: Consolidation of Power",
            "Henry VIII: Government and Reformation",
            "Edward VI and the Mid-Tudor Crisis",
            "Mary I: Religious Persecution and Reign",
            "Elizabeth I: Religious Settlement",
            "Foreign Policy under the Tudors",
            "The Elizabethan Court and Parliament",
            "Social and Economic Developments"
        ],
        "Stuart Britain and the Crisis of Monarchy (1603–1702)": [
            "James I and the Divine Right",
            "Charles I and the Road to Civil War",
            "The English Civil War",
            "Interregnum and Cromwell",
            "The Restoration of Charles II",
            "James II and the Glorious Revolution",
            "Religion and Politics in Stuart England"
        ],
        "Modern Britain (Post-1900)": [
            "The Liberal Reforms",
            "The First World War and its Aftermath",
            "The Interwar Period and Depression",
            "Post-WWII Consensus and Welfare State",
            "Thatcher and the Conservative Revolution",
            "Social Change (1950s–1990s)",
            "Race, Gender, and Immigration"
        ]
    },
    "Non-British History": {
        "Russia (1855–1964)": [
            "Alexander II’s Reforms",
            "Autocracy under Alexander III",
            "Nicholas II and the Fall of the Tsar",
            "Revolutions of 1905 and 1917",
            "Lenin and the Bolsheviks",
            "Stalin’s Rise and Rule",
            "Post-Stalin USSR under Khrushchev"
        ],
        "Germany (1918–1945)": [
            "Weimar Republic and Constitution",
            "Treaty of Versailles and Its Impact",
            "Rise of the Nazi Party",
            "Consolidation of Power (1933–1934)",
            "Nazi Economic, Social and Racial Policies",
            "Opposition and Resistance",
            "Germany During WWII"
        ],
        "USA (1865–1975)": [
            "Reconstruction and Civil Rights Post-Civil War",
            "The Gilded Age and Progressive Era",
            "The Great Depression and New Deal",
            "Civil Rights Movement (1950s–1960s)",
            "Vietnam War and Foreign Policy",
            "Watergate and Political Change",
            "Social Change and Protest Movements"
        ]
    },
    "Thematic Studies": {
        "The Crusades (1095–1204)": [
            "Origins and Causes of the Crusades",
            "First Crusade and the Capture of Jerusalem",
            "Crusader States",
            "Second and Third Crusades",
            "Key Figures: Richard I, Saladin",
            "Impact on the Muslim and Christian World",
            "Military Orders and Religious Motivation"
        ],
        "Civil Rights in the USA (1865–1992)": [
            "African American Civil Rights",
            "Native American Rights",
            "Women’s Rights Movement",
            "LGBTQ+ Rights (Modern Movements)",
            "Role of Supreme Court and Federal Government",
            "Influence of Individuals and Grassroots Movements"
        ],
        "The British Empire (1857–1967)": [
            "Indian Rebellion of 1857",
            "Expansion into Africa",
            "Economic Motives for Empire",
            "Imperial Policy and Governance",
            "Resistance and Rebellion in Colonies",
            "Decolonisation Post-WWII",
            "Legacy of the Empire"
        ]
    },
    "Historical Enquiry (NEA)": {
        "Coursework/Independent Investigation": [
            "Formulating a Historical Question",
            "Primary and Secondary Sources",
            "Interpretations and Historiography",
            "Footnoting and Referencing",
            "Critical Analysis and Evaluation",
            "Structure and Argument Development",
            "Extended Essay Writing",
            "Assessment Objectives and Marking Criteria"
        ]
    }
}

const gcse_maths = {
    "Number": {
        "Fractions, Decimals and Percentages": [
            "Fractions of amounts",
            "Converting between fractions, decimals and percentages",
            "Percentage increase and decrease",
            "Recurring decimals",
            "Fractional calculations"
        ],
        "Indices, Powers and Roots": [
            "Square and cube roots",
            "Laws of indices",
            "Standard form",
            "Surds (higher tier)"
        ],
        "Rounding and Estimation": [
            "Significant figures",
            "Decimal places",
            "Estimation in calculations"
        ],
        "Ratio and Proportion": [
            "Simplifying ratios",
            "Sharing in a ratio",
            "Direct and inverse proportion",
            "Currency conversion",
            "Scaling recipes"
        ],
        "Other Number Skills": [
            "HCF and LCM",
            "Prime factorisation",
            "Negative numbers",
            "Order of operations (BIDMAS)"
        ]
    },
    "Algebra": {
        "Expressions and Formulae": [
            "Simplifying expressions",
            "Expanding brackets",
            "Factorising",
            "Substitution",
            "Algebraic fractions (higher tier)"
        ],
        "Equations and Inequalities": [
            "Solving linear equations",
            "Solving quadratic equations (higher tier)",
            "Inequalities on a number line",
            "Simultaneous equations",
            "Changing the subject of a formula"
        ],
        "Sequences and Graphs": [
            "Linear sequences",
            "Quadratic sequences (higher tier)",
            "Plotting linear graphs",
            "Gradient and intercept",
            "Non-linear graphs (exponential, reciprocal)"
        ]
    },
    "Geometry and Measures": {
        "Properties and Constructions": [
            "Angles in triangles and polygons",
            "Parallel lines and angle facts",
            "Congruence and similarity",
            "Geometric proof (higher tier)",
            "Constructing loci"
        ],
        "Mensuration": [
            "Perimeter and area",
            "Surface area and volume",
            "Circle theorems (higher tier)",
            "Sectors and arcs",
            "Density and pressure"
        ],
        "Transformations": [
            "Reflections",
            "Rotations",
            "Translations",
            "Enlargements",
            "Combined transformations"
        ]
    },
    "Probability and Statistics": {
        "Probability": [
            "Probability scale and notation",
            "Mutually exclusive events",
            "Tree diagrams",
            "Venn diagrams",
            "Relative frequency"
        ],
        "Statistics": [
            "Averages (mean, median, mode, range)",
            "Representing data (bar charts, histograms, pie charts)",
            "Cumulative frequency (higher tier)",
            "Box plots",
            "Scatter graphs and correlation"
        ]
    }
}
const gcse_biology = {
    "Cell Biology": {
        "Cell Structure": [
            "Eukaryotic and prokaryotic cells",
            "Animal and plant cells",
            "Cell specialisation",
            "Cell differentiation",
            "Microscopy"
        ],
        "Cell Division": [
            "Mitosis and the cell cycle",
            "Stem cells"
        ],
        "Transport in Cells": [
            "Diffusion",
            "Osmosis",
            "Active transport"
        ]
    },
    "Organisation": {
        "Principles of Organisation": [
            "Levels of organisation (cells, tissues, organs, systems)"
        ],
        "Animal Organisation - Digestion": [
            "Human digestive system",
            "Enzymes and their action",
            "Factors affecting enzymes",
            "Role of bile"
        ],
        "Animal Organisation - Circulation": [
            "Heart structure and function",
            "Blood vessels",
            "The blood and its components",
            "Coronary heart disease",
            "Health and lifestyle effects"
        ],
        "Plant Organisation": [
            "Plant tissues",
            "Xylem and phloem",
            "Transpiration",
            "Translocation"
        ]
    },
    "Infection and Response": {
        "Communicable Diseases": [
            "Pathogens: bacteria, viruses, fungi, protists",
            "Measles",
            "HIV",
            "Salmonella and gonorrhoea",
            "Malaria"
        ],
        "Immune System Defence": [
            "White blood cells",
            "Vaccination",
            "Antibiotics and painkillers",
            "Drug resistance"
        ],
        "Developing Medicines": [
            "Drug development and testing",
            "Monoclonal antibodies",
            "Uses and ethical issues"
        ]
    },
    "Bioenergetics": {
        "Photosynthesis": [
            "Photosynthesis reaction and equation",
            "Factors affecting photosynthesis",
            "Uses of glucose"
        ],
        "Respiration": [
            "Aerobic respiration",
            "Anaerobic respiration",
            "Response to exercise",
            "Metabolism"
        ]
    },
    "Homeostasis and Response": {
        "Principles of Homeostasis": [
            "Homeostasis definition and examples"
        ],
        "Nervous System": [
            "Structure and function",
            "Reflex arcs",
            "Brain structure and function",
            "Investigating brain function"
        ],
        "Hormonal Coordination": [
            "Endocrine system overview",
            "Blood glucose regulation",
            "Diabetes treatment",
            "Human reproductive hormones",
            "Contraception",
            "Fertility treatments",
            "Plant hormones and their uses"
        ]
    },
    "Inheritance, Variation and Evolution": {
        "Reproduction": [
            "Sexual and asexual reproduction",
            "Meiosis"
        ],
        "Genetics": [
            "DNA and genome",
            "Genetic inheritance (Punnett squares)",
            "Genetic disorders: cystic fibrosis, polydactyly"
        ],
        "Variation and Evolution": [
            "Causes of variation",
            "Natural selection and evolution",
            "Selective breeding",
            "Genetic engineering and GM crops",
            "Cloning"
        ],
        "Evidence for Evolution": [
            "Fossils and extinction",
            "Antibiotic resistance",
            "Classification systems"
        ]
    },
    "Ecology": {
        "Ecosystems": [
            "Levels of organisation (organism, population, community, ecosystem)",
            "Biotic and abiotic factors",
            "Adaptations of organisms"
        ],
        "Cycles in Nature": [
            "Carbon cycle",
            "Water cycle"
        ],
        "Biodiversity and Human Impact": [
            "Importance of biodiversity",
            "Pollution (land, air, water)",
            "Deforestation and global warming",
            "Maintaining biodiversity"
        ],
        "Food Production": [
            "Food security",
            "Sustainable methods",
            "Biotechnology in food production"
        ]
    }
}
const gcse_english_language = {
    "Reading Skills": {
        "Comprehension": [
            "Identifying explicit information",
            "Identifying implicit information",
            "Selecting key quotations",
            "Summarising information",
            "Comparing ideas across texts"
        ],
        "Language Analysis": [
            "Commenting on word choice",
            "Analysing imagery and figurative language",
            "Examining sentence forms and structure",
            "Considering tone and atmosphere",
            "Exploring writer’s purpose and audience"
        ],
        "Structural Analysis": [
            "Identifying text organisation",
            "Commenting on openings and endings",
            "Recognising shifts in focus and perspective",
            "Analysing paragraph structure",
            "Tracking development of ideas"
        ],
        "Critical Evaluation": [
            "Evaluating writer’s methods",
            "Judging effectiveness of language and structure",
            "Exploring reader response",
            "Supporting opinions with evidence"
        ]
    },
    "Writing Skills": {
        "Creative Writing": [
            "Planning and structuring a narrative",
            "Developing characters and setting",
            "Using figurative language effectively",
            "Varying sentence forms for effect",
            "Building tension and atmosphere",
            "Writing engaging openings and endings"
        ],
        "Descriptive Writing": [
            "Showing not telling",
            "Using sensory details",
            "Creating vivid imagery",
            "Focusing on mood and tone",
            "Organising ideas logically"
        ],
        "Transactional Writing": [
            "Writing to argue and persuade",
            "Writing to inform and explain",
            "Writing speeches, letters, articles and reviews",
            "Adapting tone for purpose and audience",
            "Using rhetorical devices effectively"
        ],
        "Technical Accuracy": [
            "Spelling and punctuation rules",
            "Grammar and sentence fluency",
            "Paragraphing for clarity",
            "Using ambitious vocabulary",
            "Editing and proofreading"
        ]
    },
    "Exam Skills": {
        "Paper 1 Reading (Fiction)": [
            "Understanding assessment objectives",
            "Answering retrieval and inference questions",
            "Analysing language and structure questions",
            "Evaluating a text critically",
            "Time management strategies"
        ],
        "Paper 1 Writing (Descriptive/Narrative)": [
            "Planning and brainstorming ideas",
            "Timing for planning vs writing",
            "Responding to visual or written prompts",
            "Balancing creativity with technical accuracy"
        ],
        "Paper 2 Reading (Non-Fiction)": [
            "Comparing viewpoints across texts",
            "Identifying similarities and differences",
            "Analysing persuasive and rhetorical techniques",
            "Understanding 19th, 20th, and 21st century contexts"
        ],
        "Paper 2 Writing (Transactional)": [
            "Planning discursive or persuasive pieces",
            "Structuring arguments logically",
            "Maintaining appropriate tone and style",
            "Using connectives and cohesive devices"
        ],
        "General Exam Strategy": [
            "Understanding mark schemes",
            "Practising past papers under timed conditions",
            "Highlighting key words in questions",
            "Checking answers against assessment objectives",
            "Building stamina for extended writing"
        ]
    }
}
const gcse_chemistry = {
    "Atomic Structure and the Periodic Table": {
        "Atomic Structure": [
            "Structure of atoms (protons, neutrons, electrons)",
            "Isotopes and relative atomic mass",
            "Electronic structure",
            "Development of atomic models (Dalton to Bohr)"
        ],
        "Periodic Table": [
            "History of the periodic table (Mendeleev)",
            "Modern periodic table layout",
            "Groups and periods explained",
            "Properties of Group 1 - Alkali metals",
            "Properties of Group 7 - Halogens",
            "Properties of Group 0 - Noble gases",
            "Trends in reactivity and physical properties"
        ]
    },
    "Bonding, Structure and Properties of Matter": {
        "Types of Bonding": [
            "Ionic bonding",
            "Covalent bonding",
            "Metallic bonding"
        ],
        "Properties of Materials": [
            "Properties of ionic compounds",
            "Properties of covalent substances (simple molecules and giant structures)",
            "Properties of metals and alloys"
        ],
        "States of Matter and Changes": [
            "States of matter and particle theory",
            "Changes of state (melting, boiling, sublimation)",
            "Pure substances and mixtures"
        ],
        "Nanoscience": [
            "Nanoparticles and their uses",
            "Risks of nanoparticles"
        ]
    },
    "Quantitative Chemistry": {
        "Chemical Calculations": [
            "Relative formula mass (Mr)",
            "The mole and Avogadro’s constant",
            "Mass changes in reactions",
            "Conservation of mass and balanced equations",
            "Limiting reactants"
        ],
        "Concentration of Solutions": [
            "Concentration calculations",
            "Using concentration in practical work"
        ],
        "Titrations and Calculations": [
            "Acid-base titrations (Higher tier)",
            "Calculations using titration data",
            "Gas volumes and molar volume"
        ]
    },
    "Chemical Changes": {
        "Reactivity of Metals": [
            "Metal reactivity series",
            "Displacement reactions",
            "Extraction of metals and reduction"
        ],
        "Reactions of Acids": [
            "Reactions with metals, bases, and carbonates",
            "Making salts by neutralisation",
            "Strong and weak acids (Higher tier)"
        ],
        "Electrolysis": [
            "The process of electrolysis",
            "Electrolysis of molten ionic compounds",
            "Electrolysis of aqueous solutions",
            "Uses of electrolysis (e.g., aluminium extraction)"
        ]
    },
    "Energy Changes": {
        "Exothermic and Endothermic Reactions": [
            "Examples of exothermic and endothermic reactions",
            "Reaction profiles and energy level diagrams",
            "Activation energy and catalysts"
        ],
        "Bond Energy Calculations": [
            "Calculating energy changes (Higher tier)",
            "Bond breaking and bond forming"
        ]
    },
    "The Rate and Extent of Chemical Change": {
        "Rates of Reaction": [
            "Factors affecting rate (temperature, concentration, pressure, surface area, catalysts)",
            "Collision theory",
            "Measuring rate of reaction"
        ],
        "Reversible Reactions and Equilibria": [
            "Reversible reactions and dynamic equilibrium",
            "Le Chatelier’s principle (Higher tier)",
            "Effect of changing conditions on equilibrium"
        ]
    },
    "Organic Chemistry": {
        "Carbon Compounds": [
            "Introduction to hydrocarbons",
            "Alkanes and alkenes",
            "Combustion of hydrocarbons"
        ],
        "Reactions of Organic Compounds": [
            "Reactions of alkenes",
            "Alcohols and carboxylic acids",
            "Esters and their uses"
        ],
        "Polymers": [
            "Addition polymerisation",
            "Condensation polymerisation (Higher tier)",
            "Natural polymers (e.g., proteins, carbohydrates)"
        ]
    },
    "Chemical Analysis": {
        "Pure Substances and Mixtures": [
            "Identifying pure substances",
            "Formulations",
            "Chromatography principles and uses"
        ],
        "Tests for Gases and Ions": [
            "Tests for common gases (H2, O2, CO2, Cl2)",
            "Tests for cations (flame tests, sodium hydroxide precipitates)",
            "Tests for anions (carbonates, sulfates, halides)"
        ]
    },
    "Chemistry of the Atmosphere": {
        "Composition and Evolution of the Atmosphere": [
            "Earth’s early atmosphere",
            "Changes in atmospheric composition over time",
            "Greenhouse gases and global warming"
        ],
        "Pollutants and Their Effects": [
            "Sources of atmospheric pollutants",
            "Effects of pollutants on health and environment"
        ]
    },
    "Using Resources": {
        "Sustainable Development": [
            "Finite and renewable resources",
            "Sustainable use of materials"
        ],
        "Water and Waste Treatment": [
            "Potable water production",
            "Waste water treatment",
            "Desalination methods"
        ],
        "Life Cycle Assessments": [
            "Assessing environmental impact of products",
            "Reduce, reuse, recycle strategies"
        ],
        "Corrosion and Alloys": [
            "Rusting and its prevention",
            "Uses of alloys and their properties",
            "Ceramics, polymers and composites"
        ]
    }
}
const gcse_english_literature = {
    "Shakespeare": {
        "Study of a Shakespeare Play": [
            "Plot summary and key events",
            "Character analysis (protagonists, antagonists, secondary characters)",
            "Themes and motifs (e.g., power, ambition, love, conflict)",
            "Language and imagery (metaphors, soliloquies, symbolism)",
            "Contextual factors (Elizabethan/Jacobean society, Shakespeare’s world)",
            "Key quotations and analysis",
            "Exam question practice and model answers"
        ]
    },
    "19th Century Novel": {
        "Study of a 19th Century Novel": [
            "Plot summary and key events",
            "Character analysis (protagonists, antagonists, minor characters)",
            "Themes and motifs (e.g., social class, morality, isolation)",
            "Language and style of the author",
            "Historical and cultural context (Victorian era)",
            "Key quotations and analysis",
            "Comparing characters and themes within the text",
            "Exam strategies for analysis and evaluation"
        ]
    },
    "Modern Texts": {
        "Study of a Modern Drama or Prose": [
            "Plot overview and narrative structure",
            "Character analysis (relationships, development, flaws)",
            "Themes (e.g., conflict, identity, prejudice, responsibility)",
            "Language, form, and structure",
            "Context (post-war, contemporary issues)",
            "Significant scenes and turning points",
            "Key quotations and analysis",
            "Response to exam-style questions"
        ]
    },
    "Poetry": {
        "Anthology Poetry": [
            "Overview of set anthology poems",
            "Thematic groupings (power and conflict, love and relationships)",
            "Poetic techniques (imagery, structure, sound devices)",
            "Comparison of poems (similarities and differences)",
            "Contextual understanding of poets and historical events",
            "Key quotations and close analysis",
            "Approaches to unseen poetry"
        ],
        "Unseen Poetry": [
            "Reading and interpreting unseen poems",
            "Identifying poetic techniques quickly",
            "Developing comparative skills for unseen poems",
            "Structuring analytical responses",
            "Practice with timed unseen poetry questions"
        ]
    },
    "Exam and Revision Skills": {
        "General Exam Strategies": [
            "Time management for each paper",
            "Planning and structuring essays",
            "Using evidence and quotations effectively",
            "Linking analysis to context and themes",
            "Proofreading under exam conditions"
        ],
        "Revision Techniques": [
            "Creating revision timetables",
            "Mind maps and flashcards for themes and quotes",
            "Practice essays and feedback",
            "Memorising key quotations",
            "Group discussion and peer teaching"
        ]
    }
}
const gcse_physics = {
    "Energy": {
        "Energy Stores and Systems": [
            "Types of energy stores (kinetic, thermal, chemical, etc.)",
            "Energy transfers (mechanical, electrical, heating, radiation)",
            "Conservation of energy",
            "Calculations of work done and power",
            "Efficiency and energy dissipation"
        ],
        "Heating and Insulation": [
            "Conduction, convection, and radiation",
            "Reducing energy transfers in buildings",
            "Specific heat capacity and its applications"
        ]
    },
    "Electricity": {
        "Current, Potential Difference and Resistance": [
            "Electric current and charge",
            "Potential difference (voltage)",
            "Resistance and Ohm’s law",
            "IV characteristics for different components"
        ],
        "Series and Parallel Circuits": [
            "Characteristics of series circuits",
            "Characteristics of parallel circuits",
            "Applications of series and parallel circuits"
        ],
        "Domestic Electricity": [
            "Mains electricity (AC and DC)",
            "The National Grid",
            "Electrical power and energy calculations",
            "Safety features in domestic circuits (fuses, circuit breakers)"
        ]
    },
    "Particle Model of Matter": {
        "States of Matter": [
            "Particle model and density",
            "Changes of state (melting, boiling, sublimation)",
            "Internal energy and specific latent heat"
        ],
        "Gas Laws": [
            "Particle motion in gases",
            "Pressure and temperature relationships",
            "Volume and pressure relationships"
        ]
    },
    "Atomic Structure": {
        "The Atom": [
            "Structure of the atom",
            "Development of the atomic model (Rutherford, Bohr, Chadwick)"
        ],
        "Radioactivity": [
            "Types of radiation (alpha, beta, gamma)",
            "Half-life and radioactive decay",
            "Uses and dangers of radiation",
            "Nuclear equations"
        ],
        "Nuclear Fission and Fusion": [
            "Nuclear fission in reactors",
            "Nuclear fusion and energy production",
            "Advantages and challenges of nuclear energy"
        ]
    },
    "Forces": {
        "Forces and Their Interactions": [
            "Vector and scalar quantities",
            "Contact and non-contact forces",
            "Resultant forces and free body diagrams"
        ],
        "Work, Energy and Momentum": [
            "Work done and energy transfers",
            "Elastic potential energy",
            "Momentum and conservation of momentum",
            "Stopping distances and vehicle safety"
        ],
        "Motion": [
            "Speed, velocity and acceleration",
            "Distance-time and velocity-time graphs",
            "Newton’s laws of motion and applications",
            "Terminal velocity and factors affecting motion"
        ],
        "Forces and Pressure": [
            "Pressure in fluids",
            "Upthrust and flotation",
            "Atmospheric pressure and altitude"
        ]
    },
    "Waves": {
        "Wave Properties": [
            "Transverse and longitudinal waves",
            "Wave speed, frequency, wavelength",
            "Reflection and refraction",
            "The electromagnetic spectrum"
        ],
        "Sound and Ultrasound": [
            "Sound waves and their properties",
            "Applications of ultrasound in medicine and industry"
        ],
        "Seismic Waves": [
            "P-waves and S-waves",
            "Studying Earth’s structure using seismic waves"
        ]
    },
    "Magnetism and Electromagnetism": {
        "Magnetic Fields": [
            "Magnetic poles and fields",
            "The Earth’s magnetic field",
            "Magnetic materials and induced magnetism"
        ],
        "Electromagnetism": [
            "Electromagnets and their uses",
            "The motor effect",
            "Fleming’s left-hand rule",
            "Electric motors and generators"
        ],
        "Electromagnetic Induction": [
            "Induced potential difference",
            "Transformers and the National Grid"
        ]
    },
    "Space Physics": {
        "The Solar System and Beyond": [
            "Our solar system and orbital motion",
            "Artificial satellites and their uses",
            "Life cycle of stars (nebula, main sequence, red giant, supernova)",
            "Black holes and neutron stars",
            "Red-shift and evidence for the expanding universe"
        ]
    }
}
const gcse_economics = {
    "Introduction to Economics": {
        "Basic Economic Concepts": [
            "The economic problem: scarcity and choice",
            "Factors of production (land, labour, capital, enterprise)",
            "Opportunity cost",
            "Production possibility frontiers (PPF)",
            "Economic agents and their objectives"
        ],
        "Economic Sectors and Specialisation": [
            "Primary, secondary, tertiary sectors",
            "Division of labour and specialisation",
            "Impact of specialisation on productivity",
            "The role of money in an economy"
        ]
    },
    "How Markets Work": {
        "Demand and Supply": [
            "The law of demand and demand curves",
            "The law of supply and supply curves",
            "Shifts in demand and supply",
            "Price determination and market equilibrium",
            "Elasticity of demand and supply (PED, PES)"
        ],
        "Competitive and Non-Competitive Markets": [
            "Characteristics of competitive markets",
            "Market structures (perfect competition, monopoly, oligopoly)",
            "Market failure and government intervention",
            "Public goods and externalities (positive and negative)"
        ],
        "The Labour Market": [
            "Wages and determination of labour supply and demand",
            "Factors affecting wages",
            "Government policies affecting the labour market"
        ]
    },
    "The Role of Government and Economic Objectives": {
        "Government Economic Objectives": [
            "Economic growth",
            "Full employment",
            "Price stability (inflation and deflation)",
            "Balance of payments and trade",
            "Redistribution of income and wealth"
        ],
        "Government Policies": [
            "Fiscal policy (taxation and government spending)",
            "Monetary policy (interest rates and money supply)",
            "Supply-side policies (education, training, deregulation)",
            "Government intervention in markets"
        ],
        "Taxation and Public Spending": [
            "Types of taxes (direct and indirect)",
            "Progressive, regressive and proportional taxation",
            "Reasons for and effects of taxation",
            "Government spending priorities"
        ]
    },
    "International Trade and the Global Economy": {
        "International Trade": [
            "Imports, exports and balance of trade",
            "Advantages and disadvantages of trade",
            "Free trade and protectionism",
            "Trade blocs and international agreements"
        ],
        "Globalisation": [
            "Causes and effects of globalisation",
            "Multinational corporations (MNCs) and their impact",
            "Benefits and drawbacks of globalisation for different economies"
        ],
        "Exchange Rates": [
            "Definition and determination of exchange rates",
            "Impact of exchange rate changes on imports and exports",
            "Appreciation and depreciation of currencies"
        ],
        "Development Economics": [
            "Differences between developed and developing countries",
            "Measuring development (GDP, HDI, other indicators)",
            "Policies to promote economic development"
        ]
    },
    "Financial Markets and Personal Finance": {
        "The Role of Financial Markets": [
            "Functions of financial institutions (banks, stock markets, insurance)",
            "The role of the Bank of England",
            "Impact of interest rates on borrowers and savers"
        ],
        "Personal Finance": [
            "Managing income and expenditure",
            "Saving and borrowing options",
            "Investment and risk",
            "The role of credit and debt",
            "Financial planning and budgeting"
        ]
    }
}
const gcse_geography = {
    "Physical Geography": {
        "The Challenge of Natural Hazards": [
            "Tectonic hazards (earthquakes and volcanoes)",
            "Weather hazards (tropical storms, UK weather extremes)",
            "Climate change (evidence, causes, effects, responses)"
        ],
        "The Living World": [
            "Ecosystems and biomes",
            "Tropical rainforests (characteristics, threats, management)",
            "Hot deserts (characteristics, opportunities, challenges, management)",
            "Cold environments (polar and tundra regions, management)"
        ],
        "Physical Landscapes in the UK": [
            "Coastal landscapes (processes, landforms, management)",
            "River landscapes (processes, landforms, flooding, management)",
            "Glacial landscapes (optional: processes, landforms, management)"
        ]
    },
    "Human Geography": {
        "Urban Issues and Challenges": [
            "Urbanisation and megacities",
            "Case study of a major city in an LIC/NEE",
            "Case study of a major city in the UK",
            "Urban sustainability and planning"
        ],
        "The Changing Economic World": [
            "Development gap (measuring, causes, strategies to reduce)",
            "Case study of a LIC/NEE’s economic development",
            "UK economic changes (post-industrial economy, rural change, transport)"
        ],
        "The Challenge of Resource Management": [
            "Global resource distribution (food, water, energy)",
            "Resource management in the UK",
            "Optional resource focus (food, water or energy)"
        ]
    },
    "Geographical Applications and Skills": {
        "Issue Evaluation": [
            "Analysing sources (graphs, maps, photos, data)",
            "Decision-making skills on a contemporary geographical issue"
        ],
        "Fieldwork": [
            "Physical geography fieldwork enquiry",
            "Human geography fieldwork enquiry",
            "Data presentation and analysis",
            "Drawing conclusions and evaluating fieldwork"
        ],
        "Geographical Skills": [
            "Cartographic skills (map reading, grid references, scale)",
            "Graphical skills (bar charts, histograms, scatter graphs, isolines)",
            "Statistical skills (mean, median, mode, range, percentage change)",
            "Interpreting photographs, satellite images and GIS"
        ]
    }
}
const gcse_combined_science = {
    "Biology": {
        "Cell Biology": [
            "Cell structure (prokaryotic and eukaryotic)",
            "Microscopy and cell division",
            "Transport in cells (diffusion, osmosis, active transport)"
        ],
        "Organisation": [
            "Digestive system and enzymes",
            "The heart and blood vessels",
            "Blood and the immune system",
            "Health and disease (non-communicable and communicable)",
            "Plant tissues and transport systems"
        ],
        "Infection and Response": [
            "Pathogens and disease transmission",
            "The immune system and vaccinations",
            "Antibiotics and drug development"
        ],
        "Bioenergetics": [
            "Photosynthesis and factors affecting it",
            "Respiration (aerobic and anaerobic)"
        ],
        "Homeostasis and Response": [
            "The nervous system and reflexes",
            "Hormonal coordination (endocrine system)",
            "Control of blood glucose, water, and temperature"
        ],
        "Inheritance, Variation and Evolution": [
            "Sexual and asexual reproduction",
            "DNA, genes, and genetic inheritance",
            "Variation and natural selection",
            "Selective breeding and genetic engineering"
        ],
        "Ecology": [
            "Communities and ecosystems",
            "Distribution of organisms",
            "Biodiversity and human impacts",
            "Waste management and global issues"
        ]
    },
    "Chemistry": {
        "Atomic Structure and the Periodic Table": [
            "Atoms, elements and compounds",
            "Structure of the atom",
            "Development of the periodic table",
            "Groups and trends (Group 1, Group 7, transition metals)"
        ],
        "Bonding, Structure and Properties": [
            "Ionic, covalent and metallic bonding",
            "Properties of materials (giant structures, nanomaterials)",
            "States of matter and changes of state"
        ],
        "Quantitative Chemistry": [
            "Conservation of mass and chemical equations",
            "Relative formula mass and moles",
            "Concentration of solutions"
        ],
        "Chemical Changes": [
            "Reactivity of metals and displacement reactions",
            "Extraction of metals and reduction",
            "Acids, bases, and salts"
        ],
        "Energy Changes": [
            "Exothermic and endothermic reactions",
            "Energy profiles and bond energies"
        ],
        "Rate and Extent of Chemical Change": [
            "Factors affecting rates of reaction",
            "Reversible reactions and dynamic equilibrium"
        ],
        "Earth’s Atmosphere and Resources": [
            "History and composition of Earth’s atmosphere",
            "Greenhouse gases and climate change",
            "Sustainable development and life cycle assessments"
        ]
    },
    "Physics": {
        "Energy": [
            "Energy stores and transfers",
            "Work, power and efficiency",
            "Heating and insulation"
        ],
        "Electricity": [
            "Current, potential difference and resistance",
            "Series and parallel circuits",
            "Domestic electricity (mains supply, safety features)"
        ],
        "Particle Model of Matter": [
            "States of matter and changes of state",
            "Specific heat capacity and specific latent heat",
            "Particle motion and pressure in gases"
        ],
        "Atomic Structure": [
            "Structure of the atom and isotopes",
            "Radioactive decay and half-life",
            "Uses and risks of radiation"
        ],
        "Forces": [
            "Vectors and scalars",
            "Forces and motion (speed, acceleration, Newton’s laws)",
            "Momentum and stopping distances",
            "Forces and elasticity"
        ],
        "Waves": [
            "Wave properties (transverse and longitudinal)",
            "Sound and the electromagnetic spectrum",
            "Reflection, refraction and applications of waves"
        ],
        "Magnetism and Electromagnetism": [
            "Magnets and magnetic fields",
            "Electromagnets and their uses"
        ]
    }
}
const gcse_psychology = {
    "Biological Psychology": {
        "Structure and Function of the Nervous System": [
            "Central and Peripheral Nervous System",
            "Neurons and Synaptic Transmission",
            "Fight or Flight Response",
            "Role of Adrenaline",
            "Brain Structure and Function"
        ],
        "Brain and Neuropsychology": [
            "Structure of the Brain",
            "Lateralisation of Function",
            "Impact of Brain Injury",
            "Neurotransmitters and Behaviour",
            "Hebb’s Theory of Learning",
            "Neuroscience in Psychology"
        ]
    },
    "Cognitive Psychology": {
        "Memory": [
            "Multi-Store Model of Memory",
            "Processes of Encoding, Storage and Retrieval",
            "Types of Memory (Episodic, Semantic, Procedural)",
            "Short-term and Long-term Memory",
            "Primacy and Recency Effects",
            "Murdock’s Study",
            "Bartlett’s Theory of Reconstructive Memory"
        ]
    },
    "Developmental Psychology": {
        "Development and Early Brain Development": [
            "Piaget’s Theory of Cognitive Development",
            "Schemas and Stages",
            "Role of Education in Development",
            "Key Studies on Development",
            "Impact of Learning Styles",
            "Willingham’s Learning Theory"
        ]
    },
    "Social Influence": {
        "Conformity and Obedience": [
            "Types of Conformity",
            "Asch’s Study on Conformity",
            "Milgram’s Study on Obedience",
            "Factors Affecting Obedience",
            "Prosocial and Antisocial Behaviour",
            "Bystander Effect",
            "Zimbardo’s Prison Experiment",
            "Social and Dispositional Factors"
        ]
    },
    "Psychological Problems": {
        "Mental Health and Treatments": [
            "Definition and Prevalence of Mental Health Problems",
            "Unipolar Depression",
            "Biological and Psychological Explanations of Depression",
            "Treatment: CBT and Antidepressants",
            "Addiction",
            "Biological and Psychological Explanations of Addiction",
            "Treatment: Aversion Therapy and Self-Management"
        ]
    },
    "Research Methods": {
        "Methods and Data Handling": [
            "Types of Research Methods (Experiments, Observations, etc.)",
            "Sampling Techniques",
            "Ethical Considerations",
            "Types of Data (Quantitative/Qualitative)",
            "Descriptive Statistics",
            "Measures of Central Tendency",
            "Graphs and Charts",
            "Evaluating Research Design",
            "Validity and Reliability"
        ]
    }
}
const gcse_history = {
    "Thematic Studies": {
        "Medicine Through Time": [
            "Medieval Medicine",
            "Renaissance Medicine",
            "18th and 19th Century Medicine",
            "Modern Medicine",
            "Public Health Reforms",
            "Key Individuals (e.g. Jenner, Pasteur, Fleming)",
            "Medical Technology",
            "War and Medicine",
            "Changes in Surgery"
        ],
        "Crime and Punishment Through Time": [
            "Medieval Crime and Punishment",
            "Early Modern Period",
            "Industrial Period",
            "Modern Period",
            "Role of Law Enforcement",
            "Prisons and Punishment Methods",
            "Key Cases and Events",
            "Use of Technology in Policing"
        ]
    },
    "British Depth Studies": {
        "Elizabethan England": [
            "Elizabeth's Court and Parliament",
            "Religious Settlement",
            "Plots and Rebellions",
            "Mary, Queen of Scots",
            "Conflict with Spain",
            "Exploration and Trade",
            "Society and Culture",
            "Education and Leisure"
        ],
        "Anglo-Saxon and Norman England": [
            "Anglo-Saxon Society and Government",
            "Edward the Confessor and Succession Crisis",
            "Battle of Hastings",
            "Norman Conquest and Control",
            "Feudal System",
            "Changes to Law and Land",
            "Domesday Book",
            "Church under the Normans"
        ]
    },
    "Modern World History": {
        "Weimar and Nazi Germany": [
            "End of WWI and Treaty of Versailles",
            "Weimar Republic Challenges",
            "Rise of the Nazis",
            "Hitler's Consolidation of Power",
            "Life in Nazi Germany",
            "Propaganda and Censorship",
            "Opposition to the Nazis",
            "Persecution of Minorities"
        ],
        "Cold War": [
            "Origins of the Cold War",
            "Berlin Crisis and Airlift",
            "Cuban Missile Crisis",
            "Vietnam War",
            "Soviet Control in Eastern Europe",
            "Arms Race and Space Race",
            "Detente and Treaties",
            "End of the Cold War"
        ]
    },
    "Wider World Depth Studies": {
        "Conflict and Tension (1918–1939)": [
            "Treaty of Versailles",
            "League of Nations",
            "International Crises of the 1920s",
            "Rise of Dictators",
            "Appeasement and Hitler’s Foreign Policy",
            "Nazi-Soviet Pact",
            "Outbreak of WWII"
        ],
        "America (1920–1973)": [
            "Economic Boom in the 1920s",
            "Prohibition and Crime",
            "The Great Depression and New Deal",
            "Civil Rights Movement",
            "Post-War America",
            "American Society and Culture",
            "McCarthyism and Cold War Fear"
        ]
    }
}
const gcse_computer_science = {
    "Computer Systems": {
        "Hardware and Software": [
            "CPU Architecture",
            "Memory (RAM, ROM)",
            "Storage Devices",
            "Input and Output Devices",
            "Embedded Systems",
            "System Software",
            "Utility Software",
            "Operating Systems"
        ],
        "Systems Architecture": [
            "Von Neumann Architecture",
            "Registers and ALU",
            "Fetch-Decode-Execute Cycle",
            "Factors Affecting CPU Performance",
            "Common CPU Components"
        ],
        "Networks": [
            "Types of Networks (LAN/WAN)",
            "Network Topologies",
            "Protocols (HTTP, FTP, TCP/IP)",
            "Packet Switching",
            "Network Security",
            "Client-Server vs Peer-to-Peer",
            "Transmission Media"
        ],
        "Cyber Security": [
            "Forms of Attack",
            "Social Engineering",
            "Malware and Prevention",
            "Authentication and Encryption",
            "Firewalls and Network Policies",
            "Penetration Testing"
        ],
        "Ethical, Legal and Environmental Impacts": [
            "Legal Issues (e.g., Data Protection Act)",
            "Ethical Issues in Computing",
            "Environmental Impact of Technology",
            "Cultural and Social Impact",
            "Open Source vs Proprietary Software"
        ]
    },
    "Computational Thinking and Algorithms": {
        "Algorithms": [
            "Searching Algorithms (Linear, Binary)",
            "Sorting Algorithms (Bubble, Merge, Insertion)",
            "Flowcharts and Pseudocode",
            "Trace Tables",
            "Efficiency and Big-O Notation"
        ],
        "Computational Thinking": [
            "Abstraction",
            "Decomposition",
            "Algorithmic Thinking",
            "Pattern Recognition",
            "Problem Solving Strategies"
        ]
    },
    "Programming": {
        "Programming Fundamentals": [
            "Variables and Data Types",
            "Input and Output",
            "Operators (Arithmetic, Logical, Relational)",
            "Selection (IF statements)",
            "Iteration (FOR, WHILE loops)",
            "String Manipulation"
        ],
        "Data Structures": [
            "Lists and Arrays",
            "Records and Tuples",
            "Stacks and Queues (basic)",
            "2D Arrays"
        ],
        "Subroutines": [
            "Procedures and Functions",
            "Parameters and Arguments",
            "Scope (Local vs Global Variables)",
            "Modular Programming"
        ],
        "Defensive Design and Testing": [
            "Validation and Verification",
            "Testing (Normal, Boundary, Invalid Data)",
            "Syntax and Logic Errors",
            "Maintainability of Code"
        ]
    },
    "Data Representation": {
        "Number Systems": [
            "Binary and Denary Conversion",
            "Hexadecimal",
            "Binary Arithmetic",
            "Character Sets (ASCII, Unicode)"
        ],
        "Images and Sound": [
            "Bitmap Images",
            "Image Resolution and Colour Depth",
            "Sound Sampling",
            "File Size Calculation"
        ],
        "Compression and Storage": [
            "Lossy vs Lossless Compression",
            "Data Storage Units (bits, bytes, etc.)",
            "File Types and Formats"
        ]
    }
}


export const topics: Record<Course,  { [s: string]: { [s: string]: string[] } }>  = {
    [Course.AL_MAT]: a_level_maths,
    [Course.AL_FMA]: a_level_maths,
    [Course.AL_BIO]: a_level_biology,
    [Course.AL_CHE]: a_level_chemistry,
    [Course.AL_CS]: a_level_computer_science,
    [Course.AL_ECO]: a_level_economics,
    [Course.AL_ENG]: a_level_english_language,
    [Course.AL_LIT]: a_level_english_literature,
    [Course.AL_GEO]: a_level_geography,
    [Course.AL_HIS]: a_level_history,
    [Course.AL_PHY]: a_level_physics,
    [Course.AL_PSY]: a_level_psychology,
    [Course.GS_BIO_F]: gcse_biology,
    [Course.GS_BIO_H]: gcse_biology,
    [Course.GS_CHE_F]: gcse_chemistry,
    [Course.GS_CHE_H]: gcse_chemistry,
    [Course.GS_SCI_F]: gcse_combined_science,
    [Course.GS_SCI_H]: gcse_combined_science,
    [Course.GS_CS]: gcse_computer_science,
    [Course.GS_ECO]: gcse_economics,
    [Course.GS_ENG]: gcse_english_language,
    [Course.GS_LIT]: gcse_english_literature,
    [Course.GS_GEO]: gcse_geography,
    [Course.GS_HIS]: gcse_history,
    [Course.GS_MAT_F]: gcse_maths,
    [Course.GS_MAT_H]: gcse_maths,
    [Course.GS_PHY_H]: gcse_physics,
    [Course.GS_PHY_F]: gcse_physics,
    [Course.GS_PSY]: gcse_psychology,
}